import React from 'react';
const CardWorkflow = ({ icon, title, content, id, coming_soon }) => {
  return (
    <>
      <a
        className={`card card-workflows ${coming_soon ? 'coming-soon' : ''}`}
        href={`/solutions/combinations/${id}/${title.replace(/\s+/g, '-')}`}
        rel="noopener"
        id={title.replace(/\s+/g, '-')}
      >
        <div className="card-header">
          <img src={icon} alt="" />
          {title}
          <br />
          {coming_soon ? <div className="badge-status comingsoon mt-2">Coming Soon</div> : null}
        </div>
        <div className="card-body">{content}</div>
        <div className="card-footer">
          {/* <a href={`/workflow/${id}`} className="btn btn-secondary mx-2">
            API only
          </a> */}
          <span className="btn btn-primary">Combinations</span>
        </div>
      </a>
    </>
  );
};

export { CardWorkflow };
